export default __webpack_public_path__ + "static/media/O-044.ca4f36f1.png";